/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Seo_DescriptionInputs */

const et_service_seo_description = /** @type {(inputs: Service_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saada rohkem õigeid kliente orgaanilise otsinguga. Meie SEO teenus tõstab sinu ettevõtte nähtavust Google's ja jätab konkurendid selja taha.`)
};

const en_service_seo_description = /** @type {(inputs: Service_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get more qualified customers from organic search. Our SEO service boosts your business visibility on Google and leaves competition behind.`)
};

/**
* | output |
* | --- |
* | "Get more qualified customers from organic search. Our SEO service boosts your business visibility on Google and leaves competition behind." |
*
* @param {Service_Seo_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_seo_description = /** @type {((inputs?: Service_Seo_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Seo_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_seo_description(inputs)
	return en_service_seo_description(inputs)
});